import type { WireArticle } from '../../api/types'
import article1011 from '../../assets/dev/article-1011.jpg'
import article1025 from '../../assets/dev/article-1025.jpg'
import article1035 from '../../assets/dev/article-1035.jpg'
import article1043 from '../../assets/dev/article-1043.jpg'
import article1050 from '../../assets/dev/article-1050.jpg'
import article1067 from '../../assets/dev/article-1067.jpg'
import article1074 from '../../assets/dev/article-1074.jpg'
import article1080 from '../../assets/dev/article-1080.jpg'
import article1084 from '../../assets/dev/article-1084.jpg'
import article110 from '../../assets/dev/article-110.jpg'

const NOW = new Date().toISOString()

// A pool of realistic placeholder articles for previewing block types.
// Each has a unique title, region slugs, classification, and a real thumbnail.
export const PLACEHOLDER_ARTICLES: WireArticle[] = [
  {
    id: 'ph-0',
    title: 'Helicopter Crashes in Mountains, Rescue Teams Deployed to Remote Site',
    classification: 'U', disseminationControls: ['FOUO'],
    regions: ['russia-eurasia'],
    topics: ['military'],
    sensitive: false,
    description: 'Officials report crews are now moving through rough terrain and weather windows to reach survivors.',
    publishedAt: NOW,
    updatedAt: NOW,
    productType: 'standard',
    workflow: { stage: 'published', currentCycle: 1, cycles: [], indexing: { indexed: true } },
    thumbnail: { artifactId: 'ph-0-thumb', presignedUrl: article1011, classification: 'U', disseminationControls: ['FOUO'] },
  },
  {
    id: 'ph-1',
    title: 'Mayor Announces Surprise Plan to Turn Downtown Into a Car-Free Zone',
    classification: 'U', disseminationControls: ['FOUO'],
    regions: ['europe'],
    topics: ['politics'],
    sensitive: true,
    description: 'City officials introduced phased restrictions beginning next quarter in key business corridors.',
    publishedAt: NOW,
    updatedAt: NOW,
    productType: 'standard',
    workflow: { stage: 'published', currentCycle: 1, cycles: [], indexing: { indexed: true } },
    thumbnail: { artifactId: 'ph-1-thumb', presignedUrl: article1025, classification: 'U', disseminationControls: ['FOUO'] },
  },
  {
    id: 'ph-2',
    title: 'Ned Barring Unveils Pocket Hologram That Projects 3D Calls in the Field',
    classification: 'U', disseminationControls: ['FOUO'],
    regions: ['east-asia'],
    topics: ['cyber'],
    sensitive: false,
    description: 'The prototype targets field briefings where low-bandwidth visual context is critical.',
    publishedAt: NOW,
    updatedAt: NOW,
    productType: 'standard',
    workflow: { stage: 'published', currentCycle: 1, cycles: [], indexing: { indexed: true } },
    thumbnail: { artifactId: 'ph-2-thumb', presignedUrl: article1035, classification: 'U', disseminationControls: ['FOUO'] },
  },
  {
    id: 'ph-3',
    title: 'Abidie Shatters National Record at Rain-Soaked Invitational',
    classification: 'U', disseminationControls: ['FOUO'],
    regions: ['middle-east'],
    topics: ['politics'],
    sensitive: false,
    description: 'Analysts are evaluating whether weather volatility influenced late heat pacing.',
    publishedAt: NOW,
    updatedAt: NOW,
    productType: 'standard',
    workflow: { stage: 'published', currentCycle: 1, cycles: [], indexing: { indexed: true } },
    thumbnail: { artifactId: 'ph-3-thumb', presignedUrl: article1043, classification: 'U', disseminationControls: ['FOUO'] },
  },
  {
    id: 'ph-4',
    title: 'Library Recovers Rare Map Found Hidden in an Estate Sale Lot',
    classification: 'U', disseminationControls: ['FOUO'],
    regions: ['east-asia'],
    topics: ['politics'],
    sensitive: false,
    description: 'Conservation staff confirmed embedded markings align with a missing 19th-century set.',
    publishedAt: NOW,
    updatedAt: NOW,
    productType: 'standard',
    workflow: { stage: 'published', currentCycle: 1, cycles: [], indexing: { indexed: true } },
    thumbnail: { artifactId: 'ph-4-thumb', presignedUrl: article1050, classification: 'U', disseminationControls: ['FOUO'] },
  },
  {
    id: 'ph-5',
    title: 'Coastal Defense Network Expands Following Disputed Territorial Incident',
    classification: 'U', disseminationControls: ['FOUO'],
    regions: ['southeast-asia'],
    topics: ['military'],
    sensitive: true,
    description: 'New sensor buoys are being installed along the contested maritime boundary zone.',
    publishedAt: NOW,
    updatedAt: NOW,
    productType: 'standard',
    workflow: { stage: 'published', currentCycle: 1, cycles: [], indexing: { indexed: true } },
    thumbnail: { artifactId: 'ph-5-thumb', presignedUrl: article1067, classification: 'U', disseminationControls: ['FOUO'] },
  },
  {
    id: 'ph-6',
    title: 'Trade Delegation Returns With Preliminary Framework for Grain Corridor Renewal',
    classification: 'U', disseminationControls: ['FOUO'],
    regions: ['sub-saharan-africa'],
    topics: ['economics'],
    sensitive: false,
    description: 'Negotiators described the framework as a foundation for a longer-term ceasefire arrangement.',
    publishedAt: NOW,
    updatedAt: NOW,
    productType: 'standard',
    workflow: { stage: 'published', currentCycle: 1, cycles: [], indexing: { indexed: true } },
    thumbnail: { artifactId: 'ph-6-thumb', presignedUrl: article1074, classification: 'U', disseminationControls: ['FOUO'] },
  },
  {
    id: 'ph-7',
    title: 'Parliament Votes to Expand Emergency Powers Granted During Infrastructure Crisis',
    classification: 'U', disseminationControls: ['FOUO'],
    regions: ['southeast-asia'],
    topics: ['politics'],
    sensitive: false,
    description: 'Opposition lawmakers raised procedural objections but lacked the votes to block the measure.',
    publishedAt: NOW,
    updatedAt: NOW,
    productType: 'standard',
    workflow: { stage: 'published', currentCycle: 1, cycles: [], indexing: { indexed: true } },
    thumbnail: { artifactId: 'ph-7-thumb', presignedUrl: article1080, classification: 'U', disseminationControls: ['FOUO'] },
  },
  {
    id: 'ph-8',
    title: 'Satellite Images Reveal Renewed Activity at Dormant Missile Test Facility',
    classification: 'U', disseminationControls: ['FOUO'],
    regions: ['middle-east'],
    topics: ['military', 'terrorism'],
    sensitive: true,
    description: 'Analysts noted new vehicle tracks and what appears to be repositioned ground equipment.',
    publishedAt: NOW,
    updatedAt: NOW,
    productType: 'standard',
    workflow: { stage: 'published', currentCycle: 1, cycles: [], indexing: { indexed: true } },
    thumbnail: { artifactId: 'ph-8-thumb', presignedUrl: article1084, classification: 'U', disseminationControls: ['FOUO'] },
  },
  {
    id: 'ph-9',
    title: 'Arctic Expeditionary Team Reports Unusual Ice Shelf Fractures Near Research Station',
    classification: 'U', disseminationControls: ['FOUO'],
    regions: ['russia-eurasia'],
    topics: ['energy'],
    sensitive: false,
    description: 'Scientists say the fracture pattern does not match any previously catalogued seasonal event.',
    publishedAt: NOW,
    updatedAt: NOW,
    productType: 'standard',
    workflow: { stage: 'published', currentCycle: 1, cycles: [], indexing: { indexed: true } },
    thumbnail: { artifactId: 'ph-9-thumb', presignedUrl: article110, classification: 'U', disseminationControls: ['FOUO'] },
  },
]
